<aero-form submitButtonLabel="{{submitButtonText}}"
  (onSubmit)="saveCaption()">
  <div>
    <aero-textarea type="text" [id]="'bulbImageCarouselCaption'" [autofocus]="true" name="bulbImageCarouselCaption" [(ngModel)]="bulbImageCarouselCaption" >
    </aero-textarea>
  </div>
</aero-form>
